import React from "react";

function App() {
  return (
    <div className="contenedor">
      <h3>Política de privacidad de RDiario</h3>

      <p>
        Gracias por elegir nuestra aplicación de RDiario: Diario personal para
        registrar y reflexionar sobre tus días. Valoramos tu confianza y estamos
        comprometidos con la protección de tu privacidad. A continuación, te
        proporcionamos una descripción detallada sobre cómo recopilamos,
        utilizamos y protegemos tu información personal. Esta política de
        privacidad te ayudará a entender cómo manejamos tus datos y qué medidas
        tomamos para garantizar su seguridad. Te recomendamos leer esta política
        detenidamente para que estés completamente informado sobre tus derechos
        y nuestra forma de actuar en relación con tu información personal.
      </p>

      <ul>
        <li>
          <h4>Información Recopilada</h4>
          <p>
            La recopilación de información es decisión del usuario. Nosotros mo
            obligamos a proporcionar información personal; esta se utiliza
            únicamente para restaurar datos guardados en la aplicación.
          </p>
        </li>

        <li>
          <h4>Uso de la Información</h4>
          <p>
            El correo electrónico y la contraseña que proporcionas para generar
            una copia de seguridad se utilizan exclusivamente para restablecer
            tus datos. No compartiremos esta información con terceros fuera de
            nuestros sistemas.
          </p>
        </li>

        <li>
          <h4>Seguridad de la Información</h4>
          <p>
            Nuestra prioridad es mantener segura tu información personal.
            Utilizamos medidas de seguridad avanzadas para proteger tus datos
            contra accesos no autorizados o pérdidas.
          </p>
        </li>

        <li>
          <h4>Contacto</h4>
          <p>
            Si tienes alguna pregunta sobre nuestra política de privacidad, no
            dudes en contactarnos al correo proporcionado en la sección de
            contacto de la tienda de aplicaciones (Play Store).
          </p>
        </li>
      </ul>

      <p>
        Ten en cuenta que esta política de privacidad se aplica únicamente a la
        aplicación RDiario.
      </p>
    </div>
  );
}

export default App;
